import { Injectable } from '@angular/core';
import { IWidgetLayout } from '@fi-shared/widget/widget';
import { isDefined } from '../utils/is-defined';
import { DeepReadonly } from '@fi-shared/types/deep-readonly';

@Injectable()
export class WidgetLayoutService {
    constructor() {
        for (let i in this.Layouts) {
            if (this.Layouts.hasOwnProperty(i)) {
                this.allLayouts.push(this.Layouts[i]);
            }
        }
    }

    private allLayouts: IWidgetLayout[] = [];

    readonly Layouts: DeepReadonly<{ [property: string]: IWidgetLayout }> = {
        OneColumn: {
            Id: 'one-column',
            Placeholders: [1],
            Order: 1,
        },
        TwoColumnsEquals: {
            Id: 'two-columns-equals',
            Placeholders: [1, 2],
            Order: 2,
        },
        TwoColumnsLeftSide: {
            Id: 'two-columns-left-side',
            Placeholders: [1, 2],
            Order: 3,
        },
        TwoColumnsRightSide: {
            Id: 'two-columns-right-side',
            Placeholders: [1, 2],
            Order: 4,
        },
        TwoColumnsEqualsWideTop: {
            Id: 'two-columns-equals-wide-top',
            Placeholders: [3, 1, 2],
            Order: 5,
        },
        TwoColumnsLeftSideWideTop: {
            Id: 'two-columns-left-side-wide-top',
            Placeholders: [3, 1, 2],
            Order: 6,
        },
        TwoColumnsRightSideWideTop: {
            Id: 'two-columns-right-side-wide-top',
            Placeholders: [3, 1, 2],
            Order: 7,
        },
        TwoColumnsEqualsWideBottom: {
            Id: 'two-columns-equals-wide-bottom',
            Placeholders: [1, 2, 3],
            Order: 8,
        },
        TwoColumnsLeftSideWideBottom: {
            Id: 'two-columns-left-side-wide-bottom',
            Placeholders: [1, 2, 3],
            Order: 9,
        },
        TwoColumnsRightSideWideBottom: {
            Id: 'two-columns-right-side-wide-bottom',
            Placeholders: [1, 2, 3],
            Order: 10,
        },
        ThreeColumnsEquals: {
            Id: 'three-columns-equals',
            Placeholders: [1, 2, 4],
            Order: 11,
        },
        ThreeColumnsEqualsWideTop: {
            Id: 'three-columns-equals-wide-top',
            Placeholders: [3, 1, 2, 4],
            Order: 12,
        },
        ThreeColumnsRightSide: {
            Id: 'three-columns-right-side',
            Placeholders: [1, 2, 4],
            Order: 13,
        },
    };

    getAllLayouts(): IWidgetLayout[] {
        return this.allLayouts;
    }

    getDefaultLayout(): IWidgetLayout {
        return this.Layouts.TwoColumnsRightSide;
    }

    getLayoutById(Id: string): IWidgetLayout {
        for (let i in this.Layouts) {
            if (this.Layouts.hasOwnProperty(i) && this.Layouts[i].Id == Id) {
                return this.Layouts[i];
            }
        }
        const layout = this.allLayouts[Id].find((l) => l.id === Id);
        if (!isDefined(layout)) {
            throw 'Layout with id "' + Id + '" not found';
        }

        return layout;
    }
}
